import type { HTMLAttributes } from 'react';

import { classNames } from '@movingimage-evp/mi-ui-component-library';

import styles from './avatar.module.css';

export function Avatar({ children, className, onClick, ...props }: HTMLAttributes<HTMLElement>) {
  const isButton = onClick !== undefined;
  const Element = isButton ? 'button' : 'div';

  return (
    <Element
      className={classNames(styles.avatar, isButton && styles.avatarButton, className)}
      onClick={isButton ? onClick : undefined}
      {...props}
    >
      {children}
    </Element>
  );
}
